import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/styles';
import { NAVBAR_TEST_IDS } from '@/lib/test-ids';
import styles from './MobileMenu.module.css';
interface MobileMenuToggleProps {
  onClick: () => void;
  isMobileMenuOpen: boolean;
  className?: string;
}
export const MobileMenuToggle = t0 => {
  const $ = _c(10);
  const {
    onClick,
    isMobileMenuOpen,
    className
  } = t0;
  const t = useTranslations("Navbar");
  const t1 = isMobileMenuOpen && styles.active;
  let t2;
  if ($[0] !== className || $[1] !== t1) {
    t2 = cn("lg:hidden", className, t1, styles["hamburger-menu"]);
    $[0] = className;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t) {
    t3 = t("toggle");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className={styles["hamburger-menu__lines"]} />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== onClick || $[7] !== t2 || $[8] !== t3) {
    t5 = <Button variant="primaryLink" size="none" className={t2} onClick={onClick} data-test-id={NAVBAR_TEST_IDS.MOBILE_MENU_BUTTON} aria-label={t3}>{t4}</Button>;
    $[6] = onClick;
    $[7] = t2;
    $[8] = t3;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};